export default __webpack_public_path__ + "images/haircut.009b7ba1.svg";